<div class="container"><br>
  <div class="form-group">
    <label>{{question?.question_copy}}</label>
    <input
      type="text"
      [id]="question?.cent_aq_question_id"
      [class]="'form-control answers ' + question?.cent_aq_question_id"
      [placeholder]="question?.question_prompt ? question?.question_prompt : ''"
      [(ngModel)]="vap.answer"
      (ngModelChange)="onChange(0)">
  </div>
</div>
